import DaveKoziol from '@/data/2026/assets/images/team/dav_koziol.webp'
import GregMiller from '@/data/2026/assets/images/team/greg_miller.webp'
import HernandoMalabet from '@/data/2026/assets/images/speakers/HernandoGonzalezMalabet.webp'
import HodaSolati from '@/data/2026/assets/images/speakers/HodaSolati.jpg'
import JennaRitten from '@/data/2026/assets/images/team/jenna_ritten.webp'
import RishirajSarkar from '@/data/2026/assets/images/team/rishiraj_sarkar.webp'
import ShimaSolati from '@/data/2026/assets/images/speakers/ShimaSolati.jpg'
import ShugmiShumunov from '@/data/2026/assets/images/team/shugmi_shumunov.jpeg'
import SohamMhatre from '@/data/2026/assets/images/team/soham_mhatre.webp'
import IdaByrdHill from '@/data/2026/assets/images/team/IdaByrd-Hill.webp'
import UmeloOnyejiaka from '@/data/2026/assets/images/team/UmeloOnyejiaka.webp'
import RonaldFrohman from '@/data/2026/assets/images/team/roland_frohman.webp'
import TylerMcbeath from '@/data/2026/assets/images/team/tyler_mcbeath.webp'
import JeseekiaVaughn from '@/data/2026/assets/images/team/jeseekia_vaughn.webp'
import BrandonWelch from '@/data/2026/assets/images/team/brandon_welch.webp'

export const teamData = [
  {
    id: 1,
    name: 'Jenna Ritten',
    linkedin: 'https://www.linkedin.com/in/jritten/',
    github: 'https://github.com/jritten',
    team: 'compass',
    star: true,
    university: '',
    organization: 'IBM',
    role: 'Executive Director',
    commits: null,
    avatar: JennaRitten,
  },
  {
    id: 2,
    name: 'Dave Koziol',
    twitter: 'davekoziol',
    linkedin: 'https://www.linkedin.com/in/davekoziol/',
    github: '',
    team: 'compass',
    star: true,
    university: '',
    organization: 'Little Caesars',
    role: 'Secretary and GDG Chair',
    commits: null,
    avatar: DaveKoziol,
  },
  {
    id: 3,
    name: 'Ida Byrd-Hill',
    linkedin: 'https://www.linkedin.com/in/idabyrdhill/',
    github: '',
    team: 'compass',
    star: false,
    university: '',
    organization: 'Automation Workz',
    role: 'Treasurer and Automation Workz Chair',
    commits: null,
    avatar: IdaByrdHill,
  },
  {
    id: 4,
    name: 'Hoda Solati',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/hoda-solati/',
    github: '',
    team: 'compass',
    star: false,
    university: '',
    bio: `Hoda Solati is an award-winning UX designer working at BraunAbility blending creativity, technology, and innovation to craft inclusive, user-centered experiences. With advanced degrees in UX Design and Animation, she explores cutting-edge technologies such as VR, AR, and robotics to solve complex design challenges. Recognized at global events including DDX’25 NYC and IEEE Smart Mobility, Hoda is passionate about redefining the future of user experience through innovation and accessibility.`,
    organization: 'BraunAbility',
    role: 'Head of Human-Centered Experience Design',
    commits: null,
    avatar: HodaSolati,
  },
  {
    id: 5,
    name: 'Shima Solati',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/shima-solati/',
    github: '',
    team: 'compass',
    star: false,
    university: '',
    bio: `Shima Solati is an award-winning UX/UI designer and researcher at BraunAbility, leading efforts to advance mobility and accessibility through innovative, user-centered design. With a Master’s in User Experience Design from the College for Creative Studies and dual degrees in fashion and textiles, Shima brings a rare multidisciplinary perspective to solving complex challenges. Her expertise spans immersive and assistive technologies, VR, AR, robotics, and her portfolio includes impactful work for KUKA Robotics, the Augmented Reality Center, General Motors, and Ford. Passionate about inclusive design and emerging technologies, Shima is dedicated to creating intuitive, innovative solutions that empower all users.`,
    organization: 'BraunAbility',
    role: 'Head of Human-Centered Design Research',
    commits: null,
    avatar: ShimaSolati,
  },
  {
    id: 6,
    name: 'Roland Frohman III',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/rhfrohman3/',
    github: '',
    team: 'compass',
    star: false,
    university: '',
    organization: 'AFROTECH',
    role: 'Head of Innovation',
    commits: null,
    avatar: RonaldFrohman,
  },
  {
    id: 7,
    name: 'Rishiraj Sarkar',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/risarkar/',
    github: null,
    team: 'compass',
    star: false,
    university: 'University of Michigan - Dearborn',
    bio: `Cybersecurity graduate student working with AI privacy and network security`,
    organization: '',
    role: 'Head of Marketing and Volunteers',
    commits: null,
    avatar: RishirajSarkar,
  },
  {
    id: 8,
    name: 'Tyler McBeath',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/tyler-mcbeath-913b54102/',
    github: '',
    team: 'compass',
    star: false,
    university: '',
    organization: 'Ford Motor Company',
    role: 'Head of Logistics and NSBE Chair',
    commits: null,
    avatar: TylerMcbeath,
  },
  {
    id: 9,
    name: 'Hernando Gonzalez Malabet',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/hernando-gonzalez-malabet-baa03625/',
    github: '',
    team: 'compass',
    star: false,
    university: '',
    organization: 'General Motors',
    role: 'Head of Speakers and SHPE Chair',
    commits: null,
    avatar: HernandoMalabet,
  },
  {
    id: 10,
    name: 'Jeseekia Vaughn',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/jeseekiavaughn/',
    github: '',
    team: 'compass',
    star: false,
    university: '',
    organization: 'Detroit Black Tech',
    role: 'Head of Community and Detroit Hacker House Chair',
    commits: null,
    avatar: JeseekiaVaughn,
  },
  {
    id: 11,
    name: 'Umelo Onyejiaka',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/umelo-onyejiaka-84213524b/',
    github: '',
    team: 'compass',
    star: false,
    university: '',
    organization: 'Continental',
    role: 'Head of Social Media and DevOps Detroit Chair',
    commits: null,
    avatar: UmeloOnyejiaka,
  },
  {
    id: 12,
    name: 'Brandon Welch',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/brandon-welch-179a16338/',
    github: '',
    team: 'compass',
    star: false,
    university: '',
    organization: 'Why Not Collab Detroit',
    role: 'Head of Social Media',
    commits: null,
    avatar: BrandonWelch,
  },
  {
    id: 13,
    name: 'Greg Miller',
    linkedin: 'https://www.linkedin.com/in/gregraymiller/',
    github: 'https://github.com/shrinkray',
    team: 'devteam',
    star: false,
    topContributor: true,
    university: '',
    bio: `
	  Hello, I am the founder of Shrinkray Interactive, a UX/UI development studio in Toledo, Ohio, leaning-in on accessible, high-performance, and user-friendly web experiences. As a founding member of GDG Toledo, I connect developers and designers through events and hackathons. Collaborating with the devteam, I oversee UX Engineering for the Michigan DevFest/Detroit Compass websites creating smooth, inclusive experience for speakers, partners, and attendees. If you are seeking a friendly, versatile, and talented developer for your project, let's connect.
	`,
    organization: 'Shrinkray Interactive + GDG Toledo + Toledo Codes',
    role: 'UX Engineer',
    commits: '150',
    avatar: GregMiller,
  },
  {
    id: 14,
    name: 'Shugmi Shumunov',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/shugmishumunov/',
    github: 'https://github.com/ShugKnight24',
    team: 'devteam',
    star: false,
    topContributor: true,
    university: '',
    bio: `
      Shugmi Shumunov is a software developer who believes code is the ultimate storytelling medium. With a primary focus on the JavaScript ecosystem within e-commerce, working across the stack in various industries. Always seeking beautiful, elegant, and performant solutions while collaborating with talented, curious, and passionate engineers and tech enthusiasts.

      When the terminal is closed and his hands are off the keyboard, you'll find him lifting weights, adventuring outdoors, exploring new places, or immersed in the worlds of manga or a good book
    `,
    organization: 'Shumunov Solutions',
    role: 'Developer',
    commits: 50,
    avatar: ShugmiShumunov,
  },
  {
    id: 15,
    name: 'Soham Mhatre',
    twitter: '',
    linkedin: null,
    github: 'https://github.com/soham02',
    team: 'devteam',
    star: false,
    topContributor: true,
    university: '',
    bio: `Soham Mhatre is a developer focused on building practical, human-centered software. He works across the MERN stack with a strong focus on cloud and AI workflows. Recent projects include an image labeling system using AWS Recognition and a financial planning/learning platform with real-time persona generation. Soham enjoys translating complex, real-world requirements into simple, shippable features and cares deeply about clean APIs, accessible UIs, and measurable outcomes. Having recently graduated from Harrisburg University with a Master's in Software Engineering, he's now pursuing full-time opportunities where he can contribute end-to-end from backend services and databases to polished frontends that people love to use.  
`,
    organization: 'Mhatre Solutions',
    role: 'Developer',
    commits: 90,
    avatar: SohamMhatre,
  },
  {
    id: 20,
    name: 'Divya Lakshmi',
    github: 'https://github.com/Divyatech-hub',
    linkedin: '',
    team: 'devteam',
    star: false,
    university: '',
    bio: 'Contributor to IWD Summit schedule and calendar export improvements, focused on reliable iCal workflows and attendee-friendly UX.',
    organization: 'Compass Detroit',
    role: 'Developer',
    commits: null,
    avatar: 'https://github.com/Divyatech-hub.png',
  },
]
